import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    table: {
      columns: {
        name: {
          title: 'Card name',
        },
        owner: {
          title: 'Owner',
        },
        paymentLimit: {
          title: 'Payment limit',
        },
        status: {
          title: 'Status',
        },
      },
    },
  },
  fr: {
    table: {
      columns: {
        name: {
          title: 'Nom de la carte',
        },
        owner: {
          title: 'Titulaire',
        },
        paymentLimit: {
          title: 'Plafond de paiement',
        },
        status: {
          title: 'Statut',
        },
      },
    },
  } as const,
});

export default locales;
